import React, { useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import FooterCertificates from "../components/FooterCertificates";
import { useLanguage } from "../config/LanguageContext";
import JCreal from "../assets/aboutUs/JC.svg";
import JC from "../assets/aboutUs/image Test 1.svg";
import Mark from "../assets/aboutUs/Portrait 1.svg";
import Naomi from "../assets/aboutUs/image Test2 1.svg";
import Lineup from "../assets/teamCardImages/Lineup 1.png";
import { Helmet } from "react-helmet";

function AboutUs() {
  const { currentLanguage, translations } = useLanguage();
  const [activeTab, setActiveTab] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const team = [
    {
      name: "Jean-Claude Lafontaine",
      role: "Chief Executive Officer",
      image: JC,
      bio: [
        "I founded Innaxys in 2011 after a career in public safety both in France and in the United Kingdom with roles spanning from the technical to the commercial and management at various levels of responsibility.",
        "My aim when creating Innaxys was to make it an environment that puts innovation and customers’ voice first. We work with our clients to create the perfect fit to their requirements, as opposed to serving them with just an off-the-shelf solution. In many ways, we are the software version of a shoemaker starting from our standard Solution to make it completely the Client’s one.",
        "Jean-Claude graduated from the Ecole d'Ingenieur EIGSI Violet in France with an MSc 2 in Engineering and has also been a qualified aircraft pilot for over 25 years. He has been appointed Honorary Consul of France for the East Midlands by the French Government in 2015",
      ],
    },
    {
      name: "Mark Attenborough",
      role: "Technical Director",
      image: Mark,
      bio: [
        "I joined Innaxys in 2017 just after university and started as a graduate developer. I loved the fact that I was able to work on multiple projects but also to meet clients and work in partnership with them, which gave me a real sense of purpose in my work.",
        "As time passed, I was offered the opportunity to progress in my role to Project Lead, then Development Manager and eventually became Innaxys’ Technical Director in 2023.",
        "In my role, I wear many hats, but since we are a company that works in close collaboration with its clients, I mix project support, team coordination and still software development.",
        "Mark holds a BSc in Computer Science from the University of Nottingham.",
      ],
    },
    {
      name: "Naomi Porter",
      role: "Commercial Lead",
      image: Naomi,
      bio: [
        "I began my career in France, working in the tourism industry before returning to the United Kingdom to retrain in business and modern languages. After a period working in academia, I came to Innaxys to lend my linguistic, research, and writing skills to the commercial team, working on tender writing with the French and British commercial team.",
        "Growing from my initial commercial assistant role within the company, I now run our bid team, as well as provide client support and training where my years of experience in customer service really come into play.",
        "Naomi speaks fluent French and is a qualified translator having graduated from the University of Nottingham with a Master’s degree in Translation Studies and Interpreting. She also holds English teaching qualifications and a Bachelor’s Degree in the arts.",
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <title>About</title>
        <meta name="description" content="Learn about Innaxys" />
      </Helmet>
      <Nav />
      <div className="about-us-header">
        <div className="text-container">
          <h1 className="gray">
            {
              {
                en: "About Us",
                fr: "À propos de nous",
                de: "Über uns",
                es: "Sobre nosotros",
              }[currentLanguage]
            }
          </h1>
        </div>
      </div>
      <div className="upside-down-left-to-right-triangle-secondary"></div>
      <div className="about-us-text-container">
        <div className="about-us-text">
          {translations.aboutUs[currentLanguage].paragraphs.map(
            (paragraphs, index) => (
              <p className="secondary" key={index}>
                {paragraphs}
              </p>
            )
          )}
        </div>
      </div>
      <div>
        <div className="whole-team-container">
          <img src={Lineup} alt="The Whole Team" />
        </div>
        <div className="about-us-tabs-container">
          <div className="about-us-tabs">
            {translations.aboutUs[currentLanguage].headers.map(
              (headers, index) => (
                <div
                  tabIndex={0}
                  className={`about-us-tab ${
                    index === activeTab ? "about-us-active-tab" : ""
                  }`}
                  onClick={() => setActiveTab(index)}
                  key={index}
                  onFocus={() => setActiveTab(index)}
                >
                  <h2 className="white">{headers}</h2>
                </div>
              )
            )}
          </div>
          <div className="about-us-tab-content-container">
            {translations.aboutUs[currentLanguage].headers.map(
              (header, index) => (
                <div
                  className="about-us-tab-content"
                  key={index}
                  style={{
                    display: index === activeTab ? "block" : "none",
                  }}
                >
                  {index === 0 && (
                    <>
                      {translations.aboutUs[
                        currentLanguage
                      ].consultancy.text.map((list, listIndex) => (
                        <p className="gray" key={listIndex}>
                          {list}
                        </p>
                      ))}
                      <ul className="about-us-list">
                        {translations.aboutUs[
                          currentLanguage
                        ].consultancy.list.map((list, listIndex) => (
                          <li className="gray" key={listIndex}>
                            {list}
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                  {index === 1 && (
                    <>
                      {translations.aboutUs[currentLanguage].solutions.text.map(
                        (text, textIndex) => (
                          <p
                            className="about-us-tab-element gray"
                            key={textIndex}
                          >
                            {text}
                          </p>
                        )
                      )}
                    </>
                  )}
                  {index === 2 && (
                    <>
                      {translations.aboutUs[currentLanguage].rnd.text.map(
                        (text, textIndex) => (
                          <p
                            className="about-us-tab-element gray"
                            key={textIndex}
                          >
                            {text}
                          </p>
                        )
                      )}
                    </>
                  )}
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <div className="team-lead-cards-container">
        <h2>
          {
            {
              en: "Management Team",
              fr: "Équipe de direction",
              de: "Führungsteam",
              es: "Equipo directivo",
            }[currentLanguage]
          }
        </h2>
        <div className="team-lead-card-wrapper">
          {team.map((member, index) => (
            <div
              key={index}
              className={`team-lead-card-container ${
                activeIndex === index ? "active" : ""
              }`}
              onMouseEnter={() => setActiveIndex(index)}
            >
              <div className="team-lead-info-container">
                <div className="team-lead-details">
                  <h3 className="secondary">{member.name}</h3>
                  <p>{member.role}</p>
                </div>
                <div className="team-lead-image-container">
                  <img src={member.image} alt={member.name} />
                </div>
              </div>
              <div
                className={`biography-panel ${
                  activeIndex === index ? "visible" : ""
                }`}
              >
                {member.bio.map((paragrpah, i) => (
                  <p
                    className={
                      i === member.bio.length - 1 ? "bio-italic" : "bio-text"
                    }
                    key={i}
                  >
                    {paragrpah}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="about-us-family-container">
        <div className="family-text-wrapper">
          <h2 className="white">
            {translations.aboutUs[currentLanguage].family.header}
          </h2>
          <p className="white">
            {translations.aboutUs[currentLanguage].family.text}
          </p>
        </div>
      </div>
      <div className="upside-down-right-to-left-triangle-secondary"></div>
      <FooterCertificates />
      <Footer />
    </>
  );
}

export default AboutUs;
